<template>
  <div>
    <Header />

    <div v-show="loading" class="section loading-holder">
      <div class="loading-spinner"></div>
    </div>

    <transition enter-active-class="animated fadeIn">
      <div v-show="!loading" class="section">
        <!-- container -->
        <div class="container">
          <!-- row -->
          <div class="row">
            <div class="col-md-8">
              <!-- post content -->
              <div class="section-row no-margin-bottom">
                <h1>{{ post.title }}</h1>

                <img class="post-image" :src="post.image" alt="post image" />

                <div v-html="post.description"></div>
              </div>
              <!-- /post content -->

              <div v-show="post.attachment.length > 0" class="section-row">
                <div class="attachment-holder">
                  <a
                    :href="attachment.file"
                    target="_blank"
                    v-for="attachment in post.attachment"
                    :key="attachment.id"
                    class="item"
                  >
                    <font-awesome-icon :icon="['fas', 'paperclip']" />
                    <span>{{
                      attachment.file.substring(
                        attachment.file.lastIndexOf("/") + 1
                      )
                    }}</span>
                  </a>
                </div>
              </div>

              <!-- post tags -->
              <div class="section-row">
                <div class="post-tags">
                  <ul>
                    <li>TAGS:</li>
                    <li class="mr-1" v-for="tag in post.tag" :key="tag.id">
                      <a :href="`#/busca?tag=${tag.title}`">{{ tag.title }}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- /post tags -->

              <!-- post share -->
              <!-- <div class="section-row">
              <div class="post-share">
                <a href="#" class="social-facebook">
                  <i class="fa fa-facebook"></i>
                  <span>Compartilhe</span>
                </a>
                <a href="#" class="social-twitter">
                  <i class="fa fa-twitter"></i>
                  <span>Tweet</span>
                </a>
                <a href="#">
                  <i class="fa fa-envelope"></i>
                  <span>Email</span>
                </a>
              </div>
            </div>-->
              <!-- /post share -->

              <!-- post author -->
              <div class="section-row">
                <div class="section-title">
                  <h3 v-show="post.user.id" class="title">
                    SOBRE
                    <a
                      style="color:var(--secondary)"
                      :href="`#/autor/${post.user.id}`"
                      >{{ post.user.name }}</a
                    >
                  </h3>
                </div>
                <div class="author media">
                  <div class="media-left">
                    <a href>
                      <img
                        class="author-img media-object"
                        :src="post.user.image"
                        alt
                      />
                    </a>
                  </div>
                  <div class="media-body">
                    <p>{{ post.user.description }}</p>
                    <ul class="author-social">
                      <li v-show="post.user.facebook">
                        <a
                          :href="post.user.facebook"
                          rel="noreferrer"
                          target="_blank"
                        >
                          <i class="fa fa-facebook"></i>
                        </a>
                      </li>
                      <li v-show="post.user.twitter">
                        <a
                          :href="post.user.twitter"
                          rel="noreferrer"
                          target="_blank"
                        >
                          <i class="fa fa-twitter"></i>
                        </a>
                      </li>
                      <li v-show="post.user.instagram">
                        <a
                          :href="post.user.instagram"
                          rel="noreferrer"
                          target="_blank"
                        >
                          <i class="fa fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- /post author -->
            </div>

            <div class="col-md-4">
              <Newsletter></Newsletter>

              <!-- post widget -->
              <div class="aside-widget">
                <div class="section-title">
                  <h2 class="title">Posts Relacionados</h2>
                </div>

                <div v-show="loadingRelatedPosts" class="loading-holder">
                  <div class="loading-spinner"></div>
                </div>

                <transition enter-active-class="animated fadeInRight">
                  <div v-show="!loadingRelatedPosts">
                    <!-- post -->
                    <div
                      class="post post-widget"
                      v-for="item in relatedPosts"
                      :key="item.id"
                    >
                      <a class="post-img" :href="`#/post/${item.slug}`">
                        <img :src="item.image" />
                      </a>
                      <div class="post-body">
                        <div class="post-category">
                          <a
                            :href="`#/busca?category=${item.category[0].title}`"
                            >{{ item.category[0].title }}</a
                          >
                        </div>
                        <h3 class="post-title">
                          <a :href="`#/post/${item.slug}`">
                            <p>{{ item.title }}</p>
                          </a>
                        </h3>
                      </div>
                    </div>
                    <!-- /post -->
                  </div>
                </transition>
              </div>
              <!-- /post widget -->
            </div>
          </div>
          <!-- /row -->
        </div>
        <!-- /container -->
      </div>
    </transition>
    <!-- /SECTION -->
    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Newsletter from "../components/Newsletter";
import http from "@/http";

export default {
  name: "Post",
  components: {
    Header,
    Footer,
    Newsletter
  },
  data() {
    return {
      post: {
        user: {
          name: String
        },
        attachment: []
      },
      relatedPosts: [],
      loading: true,
      loadingRelatedPosts: true
    };
  },
  created() {
    this.loadPost();
  },
  methods: {
    loadPost() {
      http
        .get(`post/details/${this.$route.params.slug}`)
        .then(response => {
          this.post = response.data;
          this.loadRelatedPosts();
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadRelatedPosts() {
      http
        .get(`post/search?take=4&user=${this.post.category[0].title}`)
        .then(response => {
          this.relatedPosts = response.data.list;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingRelatedPosts = false;
        });
    }
  }
};
</script>
<style scoped>
.section-row {
  position: relative;
}

.section-row.no-margin-bottom {
  margin-bottom: 0;
}

p img {
  max-height: 300px !important;
}

.section {
  min-height: 300px;
}

.post-image {
  max-width: 100%;
  margin-bottom: 15px;
}

.attachment-holder {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin: -25px 0 0 -25px;
}

.attachment-holder .item {
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 25px 0 0 25px;
}

.attachment-holder .item svg {
  font-size: 1.4em;
  color: var(--secondary);
  margin-right: 6px;
}

.attachment-holder .item span {
  font-size: 1.2em;
  color: var(--secondary);
}

@media only screen and (min-width: 720px) {
  .mobile-image {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Post.vue